import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface TableFilterFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  testId: string;
}

export default function TableFilterField({
  value,
  onChange,
  placeholder,
  testId,
}: TableFilterFieldProps) {
  return (
    <TextField
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      slotProps={{
        htmlInput: { "data-testid": testId },
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        },
      }}
      sx={{ minWidth: 260 }}
    />
  );
}
